<div class="row">
  <div class="col">
    <h3>{{ 'i18n.domain.services.overview.title' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
    class="grid-with-toolbar"
    width='100%'
    rowHeight='38'
    [dataSource]='data'
    [allowSorting]='true'
    [filterSettings]='filterSettings'
    [allowFiltering]='true'
    [allowPaging]='true'
    [pageSettings]='pageSettings'
    [editSettings]='editSettings'
    [searchSettings]="searchOptions"
    (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)">
    <ng-template #toolbarTemplate let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.services.overview.add' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field='id'
        [visible]='false'
        headerText='ID'
        [isPrimaryKey]='true'></e-column>
      <e-column field='name'
        type="string"
        headerText="{{'i18n.shared.fields.name' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='description'
        type="string"
        headerText="{{'i18n.domain.services.fields.description' | translate}}"
        clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='baseStatus'
        headerText="{{'i18n.domain.services.fields.baseStatus' | translate}}">
        <ng-template #template let-data>
          {{formatBaseStatus(data)}}
        </ng-template>
      </e-column>
      <e-column field='effectiveStatus'
        headerText="{{'i18n.domain.services.fields.effectiveStatus' | translate}}">
        <ng-template #template let-data>
          {{formatStatus(data)}}
        </ng-template>
      </e-column>
      <e-column headerText="" [commands]='gridCommands' textAlign='Right'></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-service-edit-form [serviceEditForm]="gridEditForm"></app-service-edit-form>
    </ng-template>
  </ejs-grid>
</div>
